export default function Topbar() {
    return (
        <header className="mb-6 flex items-center justify-between rounded-2xl border border-rose-100 bg-white px-5 py-4 shadow-soft">
            <div>
                <p className="text-sm text-gray-500">Fashion inventory dashboard</p>
            </div>
            <div className="rounded-full bg-rose-50 px-4 py-2 text-sm font-medium text-gray-700">Admin</div>
        </header>
    );
}